const AREA_23_WARDS_OF_TOKYO = '東京23区'
const AREA_TOKYO_OUTSIDE_23_WARDS = '東京23区外'
const AREA_KANAGAWA = '神奈川'
const AREA_CHIBA = '千葉'
const AREA_SAITAMA = '埼玉'

const GENRE_ITALIAN = 'イタリアン'
const GENRE_FRENCH = 'フレンチ'
const GENRE_IZAKAYA = '居酒屋'
const GENRE_CAFE = 'カフェ'
const GENRE_JAPANESE = '和食'
const GENRE_WESTERN = '洋食'
const GENRE_BAKERY = 'ベーカリー'
const GENRE_SUSHI = '寿司'
const GENRE_CHINESE = '中華'
const GENRE_HOTEL = 'ホテル・旅館'
const GENRE_BRIDAL = 'ブライダル'
const GENRE_MASS_CATERING = '集団調理'
const GENRE_KOREAN = '韓国料理'
const GENRE_ASIAN = 'アジアン料理'

const SHOP_STAFF = '店舗スタッフ'
const POSITION_KITCHEN_STAFF = 'キッチンスタッフ'
const POSITION_SUSHI_CHEF = '寿司職人'
const POSITION_NUTRITIONIST = '栄養士・管理栄養士'
const POSITION_FRONT_STAFF = 'フロントスタッフ'
const POSITION_SERVICE_STAFF = 'レストランサービススタッフ・ホールスタッフ'
const POSITION_FOOD_AND_BEVERAGE_STAFF = '料飲スタッフ'
const POSITION_HEAD_CHEF = '料理長・料理長候補'
const POSITION_MANAGER = '店長・店長候補'
const POSITION_PATISSIER = 'パティシエ'
const POSITION_BOULANGER = 'ブーランジェ・ベーカー'
const POSITION_SUPERVISOR = 'スーパーバイザー'
const POSITION_OTHER = 'その他(仕事内容)'

const FILTER_POSITION_SERVICE_STAFF = 'サービススタッフ'
const FILTER_POSITION_HEAD_CHEF = '料理長'
const FILTER_POSITION_MANAGER = '店長'
const FILTER_POSITION_BOULANGER = 'ブーランジェ'

const instagramConfig = {
    jobs: [],

    filters: {
        area: [AREA_23_WARDS_OF_TOKYO, AREA_TOKYO_OUTSIDE_23_WARDS, AREA_KANAGAWA, AREA_CHIBA, AREA_SAITAMA],
        genre: [GENRE_ITALIAN, GENRE_FRENCH, GENRE_IZAKAYA, GENRE_CAFE, GENRE_JAPANESE, GENRE_WESTERN, GENRE_BAKERY, GENRE_SUSHI, GENRE_CHINESE, GENRE_HOTEL, GENRE_BRIDAL, GENRE_MASS_CATERING],
        position: [POSITION_KITCHEN_STAFF, FILTER_POSITION_SERVICE_STAFF, FILTER_POSITION_HEAD_CHEF, FILTER_POSITION_MANAGER, POSITION_PATISSIER, FILTER_POSITION_BOULANGER, POSITION_SUPERVISOR],
    },

    filtersList: {
        area: [
            {areaName: AREA_23_WARDS_OF_TOKYO, dataClickLabel: 'CT_Jobinformation_エリア-東京23区'},
            {areaName: AREA_TOKYO_OUTSIDE_23_WARDS, dataClickLabel: 'CT_Jobinformation_エリア-東京23区外'},
            {areaName: AREA_KANAGAWA, dataClickLabel: 'CT_Jobinformation_エリア-神奈川'},
            {areaName: AREA_CHIBA, dataClickLabel: 'CT_Jobinformation_エリア-千葉'},
            {areaName: AREA_SAITAMA, dataClickLabel: 'CT_Jobinformation_エリア-埼玉'}
        ],
        genre: [
            {genreName: GENRE_ITALIAN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-イタリアン'},
            {genreName: GENRE_FRENCH, dataClickLabel: 'CT_Jobinformation_料理ジャンル-フレンチ'},
            {genreName: GENRE_IZAKAYA, dataClickLabel: 'CT_Jobinformation_料理ジャンル-居酒屋'},
            {genreName: GENRE_CAFE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-カフェ'},
            {genreName: GENRE_JAPANESE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-和食'},
            {genreName: GENRE_WESTERN, dataClickLabel: 'CT_Jobinformation_料理ジャンル-洋食'},
            {genreName: GENRE_BAKERY, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ベーカリー'},
            {genreName: GENRE_SUSHI, dataClickLabel: 'CT_Jobinformation_料理ジャンル-寿司'},
            {genreName: GENRE_CHINESE, dataClickLabel: 'CT_Jobinformation_料理ジャンル-中華'},
            {genreName: GENRE_HOTEL, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ホテル旅館'},
            {genreName: GENRE_BRIDAL, dataClickLabel: 'CT_Jobinformation_料理ジャンル-ブライダル'},
            {genreName: GENRE_MASS_CATERING, dataClickLabel: 'CT_Jobinformation_料理ジャンル-集団調理'}
        ],
        position: [
            {positionName: POSITION_KITCHEN_STAFF, dataClickLabel: 'CT_Jobinformation_職種-キッチンスタッフ'},
            {positionName: FILTER_POSITION_SERVICE_STAFF, dataClickLabel: 'CT_Jobinformation_職種-サービススタッフ'},
            {positionName: FILTER_POSITION_HEAD_CHEF, dataClickLabel: 'CT_Jobinformation_職種-料理長'},
            {positionName: FILTER_POSITION_MANAGER, dataClickLabel: 'CT_Jobinformation_職種-店長'},
            {positionName: POSITION_PATISSIER, dataClickLabel: 'CT_Jobinformation_職種-パティシエ'},
            {positionName: FILTER_POSITION_BOULANGER, dataClickLabel: 'CT_Jobinformation_職種-ブーランジェ'},
            {positionName: POSITION_SUPERVISOR, dataClickLabel: 'CT_Jobinformation_職種-スーパーバイザー'}
        ],
    },
    parameterMapping: {
        area: {
            '神奈川県': { city_id: 725 },
            '千葉県': { city_id: 596 },
            '埼玉県': { city_id: 531 },
        },
        genre: {
            [GENRE_ITALIAN]: { genre_id: 1 },
            [GENRE_FRENCH]: { genre_id: 2 },
            [GENRE_IZAKAYA]: { genre_id: 11 },
            [GENRE_CAFE]: { genre_id: 20 },
            [GENRE_JAPANESE]: { genre_id: 5 },
            [GENRE_WESTERN]: { genre_id: 4 },
            [GENRE_BAKERY]: { genre_id: 22 },
            [GENRE_SUSHI]: { genre_id: 7 },
            [GENRE_CHINESE]: { genre_id: 17 },
            [GENRE_HOTEL]: { genre_id: 23 },
            [GENRE_BRIDAL]: { genre_id: 25 },
            [GENRE_MASS_CATERING]: { genre_id: 24 },
        },
        position: {
            [POSITION_KITCHEN_STAFF]: { occupation_id: 4 },
            [POSITION_SERVICE_STAFF]: { occupation_id: 3 },
            [POSITION_HEAD_CHEF]: { occupation_id: 2 },
            [POSITION_MANAGER]: { occupation_id: 1 },
            [POSITION_PATISSIER]: { occupation_id: 11 },
            [POSITION_BOULANGER]: { occupation_id: 12 },
            [POSITION_SUPERVISOR]: { occupation_id: 19 }
        }
    },

    jobInformationData: {
        dataClickLabels: {
            area: 'CT_Jobinformation_エリア',
            genre: 'CT_Jobinformation_料理ジャンル',
            position: 'CT_Jobinformation_職種',
        }
    },

    stepFormLabels: {
        step0: {
            dataViewLabel: 'EF_StepForm_Step0-転職意欲',
            dataClickLabels: {
                high: 'EF_StepForm_Step0-転職意欲-転職したい',
                moderate: 'EF_StepForm_Step0-転職意欲-情報収集',
                close: 'EF_StepForm_Step0-閉じる',
                blank: 'EF_StepForm_Step0-空白',
            }
        },
        step1: {
            dataViewLabel: 'EF_StepForm_Step1-現在の状況',
            dataClickLabels: {
                working: 'EF_StepForm_Step1-現在の状況-在籍中',
                unemployed: 'EF_StepForm_Step1-現在の状況-離職中',
                back: 'EF_StepForm_Step1-現在の状況-戻る',
            }
        },
        step2: {
            dataViewLabel: 'EF_StepForm_Step2-経験年数',
            dataClickLabels: {
                lessThan1: 'EF_StepForm_Step2-経験年数-1年未満',
                oneToFive: 'EF_StepForm_Step2-経験年数-1~5年',
                fiveToTen: 'EF_StepForm_Step2-経験年数-5~10年',
                moreThan10: 'EF_StepForm_Step2-経験年数-10年以上',
                back: 'EF_StepForm_Step2-経験年数-戻る'
            }
        },
        step3: {
            dataViewLabel: 'EF_StepForm_Step3-お住まい',
            dataClickLabels: {
                back: 'EF_StepForm_Step3-お住まい-戻る',
                next: 'EF_StepForm_Step3-お住まい-次へ'
            }
        },
        step4: {
            dataViewLabel: 'EF_StepForm_Step4-名前年齢',
            dataClickLabels: {
                back: 'EF_StepForm_Step4-名前年齢-戻る',
                next: 'EF_StepForm_Step4-名前年齢-次へ'
            }
        },
        step5: {
            dataViewLabel: 'EF_StepForm_Step5-連絡先',
            dataClickLabels: {
                back: 'EF_StepForm_Step5-連絡先-戻る',
                link: 'EF_StepForm_Step5-連絡先-Link-利用規約',
                cta: 'EF_StepForm_Step5-連絡先-CVボタン',
                lineCheckbox: 'EF_StepForm_Step5-連絡先-LINEチェック'
            }
        },
    },
}

export default instagramConfig